interface BrandLogoProps {
  compact?: boolean;
  showWordmark?: boolean;
  sidebar?: boolean;
}

export function BrandLogo({ compact = false, showWordmark = true, sidebar = false }: BrandLogoProps) {
  const sizeClass = compact ? 'h-6 w-6 rounded-md' : 'h-8 w-8 rounded-lg';
  const iconSize = compact ? 12 : sidebar ? 18 : 14;

  return (
    <div className={`flex items-center min-w-0 ${compact ? 'gap-2' : 'gap-3'}`}>
      <div className={`primary-gradient grid place-items-center shrink-0 ${sizeClass}`}>
        <svg
          width={iconSize}
          height={iconSize}
          viewBox="0 0 24 24"
          fill="none"
          stroke="white"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M5 16 12 5l7 11" />
          <path d="M9 16h6" />
        </svg>
      </div>

      {showWordmark && (
        <div className="min-w-0 brand-wordmark">
          <h1 className={`${compact ? 'text-sm' : 'text-xl'} font-semibold tracking-tighter text-on-background`}>
            Architect
          </h1>
          {!compact && (
            <p className="text-[10px] uppercase tracking-[0.1em] text-on-surface-variant font-medium">
              Remote Careers
            </p>
          )}
        </div>
      )}
    </div>
  );
}
